// extracted by mini-css-extract-plugin
module.exports = {"header":"Format_header__29Nfi","close":"Format_close__1rJej","content":"Format_content__3T8Qp"};